import { useCallback, useState } from 'react';
import { SimplifiedAttioValuation } from 'dashboard409a/services/attio.types';

export type AttioFilterState = {
  searchParams: {searchParam: string, searchAll: boolean};
  searchStatus: string;
  fromDate: Date | null;
  toDate: Date | null;
};

export const useAttioFilters = (
  allRows: SimplifiedAttioValuation[],
  setFilteredRows: React.Dispatch<React.SetStateAction<SimplifiedAttioValuation[]>>
) => {
  const [isSearching, setIsSearching] = useState(false);

  const applyFilters = useCallback(
    async (filterState: AttioFilterState) => {
      let filtered = [...allRows];
      const { searchParam, searchAll } = filterState.searchParams;

      if (searchParam.trim().length > 0 || searchAll) {
        setIsSearching(true);
      }

      try {

        if (filterState.searchStatus !== 'default') {
          filtered = filtered.filter(row => row.status === filterState.searchStatus);
        }

        if (filterState.fromDate) {
          filtered = filtered.filter(row => {
            if (!row.valuation_date) {
              return false;
            }
            const fromDateEndOfDay = new Date(filterState.fromDate!);
            fromDateEndOfDay.setHours(23, 59, 59, 999);
            const rowDate = new Date(row.valuation_date);
            rowDate.setHours(23, 59, 59, 999);

            return rowDate >= fromDateEndOfDay;
          });
        }

        if (filterState.toDate) {
          filtered = filtered.filter(row => {
            if (!row.valuation_date) {
              return false;
            }
            const rowDate = new Date(row.valuation_date);
            const toDateEndOfDay = new Date(filterState.toDate!);
            rowDate.setHours(23, 59, 59, 999);
            toDateEndOfDay.setHours(23, 59, 59, 999);
            return rowDate < toDateEndOfDay;
          });
        }

        setFilteredRows(filtered);
      } finally {
        setIsSearching(false);
      }
    },
    [allRows, setFilteredRows]
  );

  return { applyFilters, isSearching };
};
